<template>
  <div class="box-list">
    <div v-if="box.title == `ProductPage.selectDesign`" class="box-list__title">
      {{ $t(`${box.title}`) }}
    </div>
    <div v-else-if="box.title == 'ProductPage.selectDesignDezeen'" class="box-list__title">
      Samsung
      <img src="../../../assets/x.png" /> Dezeen
    </div>
    <div v-else-if="box.title == 'ProductPage.selectDesignSoccer'"  class="box-list__title">
     Samsung
     <a  v-if="lang === 'en'">
      <img  src="../../../assets/x.png" /> Soccer</a>
      <a v-else>
        <img  src="../../../assets/x.png" /> Football</a>
  </div>
  <div v-else  class="box-list__title">
      Samsung
      <img src="../../../assets/x.png" /> Disney
  </div>
    <div class="box-list__filters">
      <ul>
        <li
          :class="{ active: selectedFilter === item }"
          v-for="(item, i) in filterList"
          :key="i"
          @click="selectedFilter = item"
        >
          {{ item }}
          <div></div>
        </li>
      </ul>
    </div>
    <div class="box-list__items">
      <ul>
        <a
          v-for="(item, i) in filteredList"
          :key="item.key"
          @click.prevent="onClickBoxRoute(i, item)"
          class="box-list-item"
        >
          <li>
            <div class="box-list-item__image" ref="itemImage">
              <img :src="item.image.pc" />
              <!-- :srcset="`${item.image.pc} 1024w, ${item.image.mobile} 360w`" -->
            </div>
            <div class="box-list-item__description" ref="itemDescription">
              <div
                v-if="$t(item.title).includes('\n')"
                class="box-list-item__title primary-text-color"
                :class="[item.level ? ' ' : 'dezeen']"
                v-html="
                  item.text
                    ? $t(item.title).replace(/(?:\r\n|\r|\n)/g, '<br/>') +
                      '&nbsp' +
                      item.text
                    : $t(item.title).replace(/(?:\r\n|\r|\n)/g, '<br/>')
                "
              >
                {{ item.text }}
              </div>
              <div
                v-else
                class="box-list-item__title primary-text-color"
                :class="[item.level ? ' ' : 'dezeen']"
              >
                {{ $t(item.title) }}&nbsp;
                {{ item.text ? item.text : "" }}
              </div>
              <div v-if="item.level" class="box-list-item__star">
                <img
                  v-for="i in [1, 2, 3, 4, 5]"
                  :src="
                    i <= item.level
                      ? require('./assets/star_pc.png')
                      : require('./assets/star_pc_empty.png')
                  "
                  :key="i"
                />
              </div>
              <div
                v-if="item.level"
                class="box-list-item__minutes secondary-text-color"
              >
                <img class="clock" src="../../../assets/icons/clock-pc.png" />
                {{ item.minutes }} {{ $t("ProductPage.mins") }}
              </div>
              <div
                class="box-list-item__inches secondary-text-color"
                :class="[item.level ? ' ' : 'dezeen']"
              >
                <span
                  v-if="
                    item.allowInches.length === 1 ||
                    item.allowInches.length !== filterList.length - 1
                  "
                >
                  <span v-for="(inch, i) in item.allowInches" :key="i">
                    {{ inch }}
                    <span v-if="i !== item.allowInches.length - 1">/</span>
                  </span>
                </span>
                  <span v-if="branchCategory == true">
                    <span
                      v-if="
                        item.allowInches.length !== 1 &&
                        item.allowInches.length === filterList.length - 1 
                      "
                      >{{$t("ProductPage.allBoxSize") }}</span
                    >
                    <span v-else-if="item.allowInches.length === 1">{{
                      $t("ProductPage.in")
                    }}</span>
                    <span v-else-if="item.allowInches.length !== 1">{{
                      $t("ProductPage.in")
                    }}</span></span>

                  <span v-else>
                  </span>

              </div>
            </div>
          </li>
        </a>
      </ul>
    </div>
  </div>
</template>

<script>
import { CategoryLists } from "@/models/CategoryKey";
import { categories } from "@/models/categories";
import { language } from "../../../util/language";

export default {
  props: {
    box: {
      type: Object,
      default: () => ({}),
    },
    categoryKey: {
      type: String,
      default: () => CategoryLists.Lifestyle.list.Serif,
    },
  },

  data() {
    return {
      selectedFilter: this.$t("ProductPage.all"),
      ref: undefined,
      active: false,
      inchActive:true,
      lang: ".",
    };
  },
  methods: {
    async onClickBoxRoute(i, box) {
      await this.$nextTick();
      this.$router.push({
        name: "BoxDetail",
        params: {
          boxKey: box.key,
          boxCover: box,
          categoryKey: this.categoryKey,
        },
      });
    },
  },
  created() {
       this.lang = language.getLanguage();
  },
  computed: {
    branchCategory(){
      if(this.categoryKey == 'BespokeJet')
          return false;
      else if(this.categoryKey == 'BespokeJetStation')
          return false;
      else if(this.categoryKey == 'BespokeJetNCleanStation')
          return false;
      else if(this.categoryKey == 'bespoke_cubeAir53')
          return false;
      else if(this.categoryKey == 'bespoke_cubeAir70')
          return false;
      else if(this.categoryKey == 'bespoke_cubeAir106')
          return false;
      else if(this.categoryKey == 'bespoke_cubeAir123')
          return false;
      else if(this.categoryKey == 'Bespoke_slim')
          return false;  
      else if(this.categoryKey =="TheFreestyle")
          return false; 
      else if(this.categoryKey =="BespokeSlimCleanStation")
          return false; 
      else if(this.categoryKey =="JetCleanStation")
          return false; 
      else if(this.categoryKey =="BlueSky")
          return false;
      else if(this.categoryKey =="BlueSky3000")
          return false;
      else if(this.categoryKey =="BlueSky3100")
          return false;
      else if(this.categoryKey =="BlueSky5000")
          return false;
      else if(this.categoryKey =="Soundtower")
          return false; 
      else if(this.categoryKey =="Soundbar")
          return false;
      else if(this.categoryKey =="BespokeJetbot")
          return false;  
      else if(this.categoryKey =="BespokeJetbotPlus")
          return false;  
      else if(this.categoryKey =="BespokeJetbotAI")
          return false;  
      else if(this.categoryKey =="LATIN")
          return false;  
      else if(this.categoryKey =="LATIN10")
          return false;    
      else if(this.categoryKey =="MIRROR")
          return false;  
      else if(this.categoryKey =="MW5100J")
          return false;  
      else if(this.categoryKey =="STENA")
          return false;  
      else
          return  true;
    },
    filterList() {
      const targets = categories[this.categoryKey].box.list.reduce(
        (pre, cur) => {
          cur.allowInches.forEach((v) => {
            pre[v] = true;
          });
          return pre;
        },
        {}
      );
      return [this.$t("ProductPage.all"), ...Object.keys(targets)];
    },
    filteredList() {
      if (this.selectedFilter === this.$t("ProductPage.all")) {
        return this.box.list;
      } else {
        return this.box.list.filter((v) =>
          v.allowInches.some((i) => i == this.selectedFilter)
        );
      }
    },
  },
};
</script>

<style>
.box-list {
  background-color: #111111;
  padding-top: 7.22vw;
  /* min-height: 100vh; */
}
.box-list .box-list__title {
  font-size: 1.84rem;
  text-align: center;
  margin-bottom: 7.22vw;
  font-weight: 700;
}

.box-list .box-list__title img {
  width: 1.84rem;
  vertical-align: middle;
}
.box-list .box-list__filters {
  color: #aaaaaa;
  margin: auto;
  /* max-width: 600px; */
}
.box-list .box-list__filters ul {
  /* max-width: 600px; */
  list-style: none;
  padding: 0 10px;
  margin: auto;
  display: flex;
  justify-content: center;
  /* width: 220px; */
  /* max-width: 300px; */

  max-width: 1200px;
}
.box-list .box-list__filters li {
  font-size: 0.91rem;
  width: 36px;
  margin-right: 20px;
  text-align: center;
  cursor: pointer;
}
.box-list .box-list__filters li:last-child {
  margin-right: 0;
}
.box-list .box-list__filters li.active div {
  border-top: 1px solid #777777;
  border-bottom: 1px solid #444444;
  width: 100%;
  margin: auto;
  margin-top: 5px;
  transition: width 0.3s;
  animation: filter-active 0.2s;
}
.box-list__items {
  display: flex;
  justify-content: center;
  margin-top: 6.94vw;
  /* margin-left: 20px;
  margin-right: 20px; */
}
.box-list-item {
  display: flex;
  position: relative;
  background-color: black;
  max-width: 320px;
  width: 320px;
  border-radius: 20px;
  justify-content: flex-start;
  padding: 20px;
  align-items: center;
  margin: auto;
  margin-bottom: 25px;
  cursor: pointer;
  box-sizing: border-box;
}
@media (max-width: 1023px) {
  .box-list-item li {
    display: flex;
    position: relative;
    background-color: black;
    max-width: 320px;
    width: 320px;
    /* border-radius: 20px; */
    justify-content: flex-start;
    padding: 0px;
    align-items: center;
    margin: auto;
    /* margin-bottom: 25px; */
    cursor: pointer;
    box-sizing: border-box;
  }
}
.box-list-item__image {
  /* max-width: 50%; */
  height: 144px;
  width: 144px;
  margin-right: 20px;
}

/* .dezeen .box-list-item__image img {
  padding: 20px;
  width: 104px;
  height: 104px;
  object-fit: contain;
} */

.box-list-item__image img {
  /* max-width: 100%;
  max-height: 32.5vw; */
  /* margin-right: 26px; */
  padding: 20px;
  width: 104px;
  height: 104px;
  object-fit: contain;
}
.box-list-item__title {
  font-size: 1.5rem;
  font-weight: 700;
  word-break: break-word;
}
.box-list-item__star {
  margin-top: 6px;
  margin-bottom: 6px;
  /* max-width: 15px; */
}
.box-list-item__star img {
  width: 17px;
}
.box-list-item__description {
  text-align: left;
}

.box-list-item__inches.secondary-text-color.dezeen {
  font-size:14px;
  margin-top: 10px;
}

.clock {
  width: 10px;
}

@keyframes filter-active {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}

@media (min-width: 1024px) {
  .box-list {
    padding-top: 120px;
    padding-bottom: 120px;
    min-height: 100vh;
  }
  .box-list .box-list__title {
    font-size: 3.29rem;
    font-weight: 700;
  }
  .box-list .box-list__title img {
    width: 3rem;
    vertical-align: middle;
  }

  .box-list .box-list__filters li {
    font-size: 1.6rem;
    width: 110px;
    font-weight: 400;
    margin-right: 70px;
  }
  .box-list .box-list__filters li:last-child {
    margin-right: 0px;
  }

  .box-list .box-list__filters ul {
    /* max-width: 600px; */
    max-width: 950px;
  }
  .box-list .box-list__filters li.active div {
    border-top: 2px solid #777777;
    width: 100%;
    margin: auto;
    margin-top: 10px;
  }
  .box-list__items {
    justify-content: center;
    max-width: 1230px;
    margin: auto;
    margin-top: 80px;
  }
  .box-list__items ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin: 0 -15px;
    justify-content: flex-start;
  }
  .box-list-item {
    flex-direction: column;
    max-width: 380px;
    width: 100%;
    box-sizing: border-box;
    padding-top: 0;
    padding-bottom: 55px;
    padding-left: 40px;
    padding-right: 40px;
    align-items: flex-start;
    /* padding-right: 40px; */
    margin: 0;
    margin-bottom: 35px;
    margin-right: 15px;
    margin-left: 15px;
    height: 530px;
    /* margin: 15px; */
    /* flex-basis: 380px; */
    /* width: 100%; */
  }
  .box-list-item.dezeen {
    padding-bottom: 35px;
  }

  .box-list-item .box-list-item__title {
    font-size: 1.6rem;
    font-weight: 700;
    margin-top: 25px;
  }

  .box-list-item__inches.secondary-text-color.dezeen {
    margin-top: 20px;
  }

  .box-list-item .box-list-item__image {
    max-width: none;
    margin-right: auto;
    margin-left: auto;
    display: flex;
    justify-content: center;
    /* margin-top: 15px; */
    height: 300px;
    width: 300px;
  }
  .box-list-item .box-list-item__image img {
    margin-left: auto;
    display: inline-block;
    /* max-width: 80%; */
    margin-top: 20%;
    width: 70%;
    height: 70%;
    margin-right: auto;
    /* width: auto; */
    height: auto;
    object-fit: contain;
  }
  /* .box-list-item.dezeen .box-list-item__image img {
  } */

  .box-list-item .box-list-item__star img {
    width: 20px;
    margin-right: 5px;
  }
  .box-list-item .box-list-item__minutes {
    margin-top: 10px;
  }
  .box-list-item .box-list-item__minutes,
  .box-list-item .box-list-item__inches {
    font-size: 1.3rem;
    font-weight: 500;
  }
  /* .box-list-item .box-list-item__inches {
    font-size: 22px;
    font-weight: 500;
  } */
  .box-list-item__description {
    margin-left: 62px;
    margin-right:22px;
  }
  .clock {
    width: 12px;
    height: auto;
  }
  .box-list-item__inches.secondary-text-color.dezeen {
  font-size:1.3rem;
}

}
@media (max-width: 1200px) {
  .box-list__items ul {
    justify-content: center;
  }
}

@media (max-width: 500px) {
  .box-list-item__inches.secondary-text-color,
  .box-list-item__minutes.secondary-text-color {
    font-size: 14px;
  }
  .box-list-item__title{
    font-size:16px;;
  }
  .box-list-item__inches.secondary-text-color.dezeen {
  font-size:14px;
}
}
</style>
